import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';
let mainColor = variables['colors-mc-primary'];

const SendingIcon = React.memo(function SendingIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(13)}
      height={remCss(13)}
      viewBox='0 0 13 13'
      style={{ position: 'relative', top: remCss(-3) }}
    >
      <g transform='translate(0 0.106)'>
        <rect width='13' height='13' transform='translate(0 -0.106)' fill='#fff' opacity='0' />
        <g id='clock-history' transform='translate(1.733 1.765)' opacity='0.5'>
          <path
            d='M8.307.607Q8.154.6,8,.6V0q.176,0,.351.013L8.307.607ZM9.5.875A4.172,4.172,0,0,0,8.914.7l.13-.581a4.706,4.706,0,0,1,.671.2L9.5.875Zm.816.423q-.128-.085-.262-.161l.294-.518a4.781,4.781,0,0,1,.583.39l-.366.47q-.121-.095-.249-.18ZM11.41,2.365a4.164,4.164,0,0,0-.389-.474l.431-.411a4.971,4.971,0,0,1,.445.542Zm.443.805q-.059-.142-.127-.279l.532-.268a4.752,4.752,0,0,1,.268.648l-.566.186q-.048-.146-.107-.288Zm.316,1.494a4.165,4.165,0,0,0-.06-.611l.587-.1a4.8,4.8,0,0,1,.069.7l-.6.015Zm-.078.916c.02-.1.036-.2.048-.3l.592.073a4.741,4.741,0,0,1-.137.688l-.574-.159q.041-.147.071-.3ZM11.523,7a4.209,4.209,0,0,0,.29-.541l.545.241a4.808,4.808,0,0,1-.331.618Zm-.574.718q.109-.109.209-.225l.452.389q-.115.133-.239.257Z'
            transform='translate(-3.232)'
            fill={mainColor}
          />
          <path
            d='M4.765.6A4.17,4.17,0,1,0,7.714,7.715l.421.421A4.767,4.767,0,1,1,4.765,0Z'
            transform='translate(0.004 0)'
            fill={mainColor}
          />
          <path
            d='M7.3,3a.3.3,0,0,1,.3.3V6.4L9.531,7.508a.3.3,0,0,1-.3.517L7.15,6.833A.3.3,0,0,1,7,6.575V3.3A.3.3,0,0,1,7.3,3Z'
            transform='translate(-2.827 -1.213)'
            fill={mainColor}
          />
        </g>
      </g>
    </svg>
  );
});

const SentIcon = React.memo(function SentIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(13)}
      height={remCss(13)}
      viewBox='0 0 13 13'
      style={{ position: 'relative', top: remCss(-3) }}
    >
      <g id='Message_Sent' data-name='Message Sent' transform='translate(-8066 -1005)'>
        <rect width='13' height='13' transform='translate(8066 1005)' fill='#fff' opacity='0' />
        <path
          d='M9.494,11.486,3.583,17.4a.133.133,0,0,1-.188,0L.039,14.04a.133.133,0,0,1,0-.188l.816-.816a.133.133,0,0,1,.188,0l2.447,2.447,5-5a.133.133,0,0,1,.188,0l.815.816A.133.133,0,0,1,9.494,11.486Z'
          transform='translate(8067.734 998.024)'
          fill={mainColor}
          opacity='1'
        />
      </g>
    </svg>
  );
});

const ReadIcon = React.memo(function ReadIcon({
  fill = variables['colors-mc-primary'],
  width = 17.585,
  height = 9.38,
  viewBox = '0 0 17.585 9.38'
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
      style={{ position: 'relative', top: remCss(-4) }}
    >
      <path
        d='M14.31,4.5a.587.587,0,0,0-.83-.83L5.689,11.463,2,7.774a.587.587,0,1,0-.83.83l4.1,4.1a.586.586,0,0,0,.83,0ZM9.377,12.707l-1.05-1.052.829-.829.637.637,7.791-7.792a.587.587,0,0,1,.83.83l-8.206,8.206a.586.586,0,0,1-.83,0Z'
        transform='translate(-0.999 -3.499)'
        fill={fill}
      />
      <path
        d='M5.5,7.171l1.05,1.052-.829.829L4.671,8a.587.587,0,1,1,.83-.83Z'
        transform='translate(-0.396 -2.896)'
        fill={fill}
      />
    </svg>
  );
});

const SendStatusIcon = React.memo(function SendStatusIcon({ state = 'read' }) {
  switch (state) {
    case 'sending':
      return <SendingIcon />;
    case 'sent':
      return <SentIcon />;
    case 'read':
      return <ReadIcon />;
    default:
      console.warn('SendStatusIcon: unknown state', state);
      return null;
  }
});
export default SendStatusIcon;
